<template>
  <div>
    <section class="small-12 medium-12 large-12 columns">
      <h1 v-html="vueModel.ContentViewModel.Step3Content.StepTitle" />
      <article>
        <scalepoint
          v-model="vueModel.CreateClaimEntity.ProductSpecific.ScalePointEntity"
          :scalepoint-view-model="stepModel.ProductSpecific.ScalepointViewModel"
          :tracking-vm="trackingVm"
        />
      </article>
    </section>
  </div>
</template>
<script>
import ReportClaimMixin from '../ReportClaimMixin.vue';
import Scalepoint from '../../components/Scalepoint.vue';

export default {
    name: 'ReportClaimContentStep3',
    components: {
        Scalepoint
    },
    mixins: [ReportClaimMixin],
    props: {
        vueModel: {
            type: Object,
            default() {
                return {};
            }
        },
        trackingVm: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            stepModel: this.vueModel.CreateClaimStep3Model
        };
    }
};
</script>
